(function () {
  if (!window.B2B?.enabled) return;

  const REQUIRED_TAG = 'espresso_bar_iasi';

  let updating = false;
  let lastNote = null;

  const TARGET_CATEGORIES = ["Single Origin", "Rarities", "Competition"];
  const MIN_KG = 100;
  const DISCOUNT_PERCENT = 15;

  const customerTags = window.B2B.customerTags || [];
  if (!customerTags.includes(REQUIRED_TAG)) return;

  // ==========================
  // CALCUL CATEGORY DATA
  // ==========================
  function calculate(cart) {
    const categoryData = {};

    cart.items.forEach(item => {
      const category = item.product_type;

      if (!TARGET_CATEGORIES.includes(category)) return;

      const kg = (item.grams * item.quantity) / 1000;
      const subtotal = item.final_line_price / 100;

      if (!categoryData[category]) {
        categoryData[category] = { kg: 0, subtotal: 0 };
      }

      categoryData[category].kg += kg;
      categoryData[category].subtotal += subtotal;
    });

    return categoryData;
  }

  // ==========================
  // BUILD NOTE
  // ==========================
  function buildNote(categoryData) {
    const eligible = Object.entries(categoryData).filter(
      ([_, data]) => data.kg >= MIN_KG
    );

    if (!eligible.length) return '';

    const lines = eligible.map(([category, data]) => {
      const discount = data.subtotal * (DISCOUNT_PERCENT / 100);

      return `${category}
${data.kg.toFixed(1)}kg
Discount: -${discount.toFixed(2)} lei`;
    });

    return `15% B2B Discount:
${lines.join('\n\n')}`;
  }

  // ==========================
  // UPDATE NOTE
  // ==========================
  async function updateNote() {
    if (updating) return;

    const res = await fetch('/cart.js');
    const cart = await res.json();

    const categoryData = calculate(cart);
    const note = buildNote(categoryData);

    if (note === lastNote) return;

    updating = true;

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note })
    });

    lastNote = note;
    updating = false;
  }

  // ==========================
  // RUN + LISTENERS
  // ==========================
  function run() {
    setTimeout(updateNote, 200);
  }

  run();

  document.addEventListener('input', run);
  document.addEventListener('click', run);
  document.addEventListener('cart:updated', run);

})();